<template>
	<b-card no-body img-top :img-alt="car.car_brand+' '+car.car_model+' '+car.year" class="" border-variant="light">
		<b-link vertical-align="end" :to="'/auto/'+car.id" class="img-container">
			<b-card-img-lazy :src="car.featured_photo.url_image" style="display: inline-block; vertical-align: top;"></b-card-img-lazy>
		</b-link>
		<div v-if="car.business_line.toUpperCase() == 'LIQUIDACIONES'" class="text-center bg-macal text-white liquidation-banner">LIQUIDACIÓN CONCURSAL</div>
		<b class="bg-white text-macal p-1 px-2 grade-car" v-if="car.inspection_grade" >
			<b>{{car.inspection_grade.replace(".",",")}}</b>
		</b>
		<font-awesome-layers class="fa-2x favourite-car" v-if="is_favourite" @click="remove_favorite()">
			<font-awesome-icon :icon="['fas', 'heart']" />
			<font-awesome-icon :icon="['fal', 'heart']" />
		</font-awesome-layers>
		<font-awesome-layers class="fa-2x non favourite-car" v-else @click="add_favorite()">
			<font-awesome-icon :icon="['fas', 'heart']" :style="{ color: 'white' }" />
			<font-awesome-icon :icon="['fal', 'heart']" />
		</font-awesome-layers>
		<b-card-body class="p-2">
			<b-card-text v-if="car">
				<b-row>
					<b-col md="8" xl="6" class="text-right" order="2" order-md="2">
						<small class="text-right">
							<font-awesome-icon :icon="['fal', 'gavel']" /> <b>{{car.auction.auction_date | moment("utc", "DD-MM-YYYY")}}</b>
						</small>
					</b-col>
					<b-col md="4" xl="6" order="2" order-md="1" class="float-left">
						<small v-if="car.featured">
							<b-badge variant="macal" size="sm">DESTACADO</b-badge>
						</small>
					</b-col>
					<!--
					<b-col md="6" order-md="1">
						<b-badge variant="dark" size="lg">Garantizado</b-badge>
					</b-col>
					-->
				</b-row>
					<small>
						<b-badge variant="light-grey" size="sm">{{car.car_type}}</b-badge> <b-badge variant="light-grey" size="sm">{{car.car_fuel_type}}</b-badge>
					</small>
				<p class="m-0 text-black">
					<b-link :to="'/auto/'+car.id">
					<b>{{car.car_brand}}</b><br />
					{{car.model_nsr}} {{car.version_nsr}} {{car.car_traction}} {{car.engine_size}}<br />
					<small><b>{{car.year}}</b></small>
					</b-link><br />
				</p>
				<h4 class="text-macal text-center m-0 mb-1">
					<small>Precio mínimo</small><br/>
					<span v-if="car.price != null">
						<b v-if="car.price != 0"><span>$</span>{{car.price | numberFormat}}</b><b v-else><span>$</span>0</b>
					</span>
					<span v-else>
						<b><span>$</span>Próximamente</b>
					</span>
				</h4>
			</b-card-text>
		</b-card-body>
	</b-card>
</template>

<script>
	export default {
	name: 'v-car-card',
	components: {
		
	},
	props: {
		car: {
			id: {type: String, default: null},
			featured_photo: {
				url: {type: String, default: null}
			},
			inspection_grade: {default: null},
			car_brand: {type: String, default: null},
			car_type: {type: String, default: null},
			car_model: {type: String, default: null},
			year: {type: String, default: null},
			price: {default: null},
			auction: {type: String, default: null},
			photo: {type: String, default: null},
			favourite: {type: Boolean, default: false},
			operational_id: {type: String, default: null}
		}
	},
	data(){
		return {
			is_favourite: false,
			is_liquidation: this.car.business_line.toUpperCase() == "LIQUIDACIONES"
		}
	},
	mounted(){
		if(this.$store.state.favorites){
			this.is_favourite = this.$store.state.favorites.includes(parseInt(this.car.id))
		}
	},
	methods:{
		add_favorite(){
			const cur = this;
			if(this.$store.state.isLogged){
				cur.is_favourite = true;
				cur.$store.commit('add_favorite', cur.car.id)
				this.axios.post("users/favorite", {operational_id: this.car.operational_id, cookie: this.$cookies.get("MCart")}).then(result => {
					if(result.data.response){
						cur.is_favourite = true;
						var key = Object.keys(result.data.cookie)[0]
						var value = result.data.cookie[key];
						var cookie_domain = process.env.NODE_ENV == "production" ? ".macal.cl" : null
						this.$cookies.set(key, value, result.data.max_session_cookie, null, cookie_domain);
						var link = "https://www.macal.cl/Carro/AbonoNuevaWebOnline?autocavid="+cur.car.operational_id;
						var el = document.getElementById('operational-favourite-link');
						el.value= link;
						el.dispatchEvent(new Event('input'));
						this.$bvToast.show('favourite-toast');
					}
				})
				.catch(() => {
				})
			}else{
				this.$store.commit('set_login_favorite', { operational_id: cur.car.operational_id, inner_id: cur.car.id });
				this.$bvModal.show('modal-login');
			}
		},
		remove_favorite(){
			const cur = this;
			cur.is_favourite = false;
			cur.$store.commit('remove_favorite', cur.car.id)
			this.axios.delete("users/unfavorite", {params: {operational_id: this.car.operational_id, cookie: this.$cookies.get("MCart")}}).then(result => {
				if(result.data.response){
					cur.is_favourite = false;
					var key = Object.keys(result.data.cookie)[0]
					var value = ""
					if(result.data.cookie[key] == null){
						value = "";
					}else{
						value = result.data.cookie[key];
					}
					var cookie_domain = process.env.NODE_ENV == "production" ? ".macal.cl" : null
					this.$cookies.set(key, value, result.data.max_session_cookie, null, cookie_domain);
				}
			})
			.catch(() => {
			})
		}
	},
	watch: {
		'$store.state.favorites': {
			handler: function()  {
				if(this.$store.state.favorites){
					this.is_favourite = this.$store.state.favorites.includes(parseInt(this.car.id));
				}
			},
			deep: true,
			immediate: true
		}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	@media (max-width: 600px){
		.img-container{
			height: 100px !important;
		}
	}
	.img-container{
		height: fit-content !important;
		overflow-y: hidden;
		text-align: center;
	}
	.img-container img{
		width: 100%;
		vertical-align: bottom;
		/* height: 100%;
		min-width: 100%; */
	}
</style>
